const tips = [
  {
    id: 1,
    icon: 'ri-drop-line',
    title: 'Stay Hydrated',
    description: 'Drink at least 8 glasses of water daily. Add lemon or cucumber for flavor and extra nutrients.',
  },
  {
    id: 2,
    icon: 'ri-sun-line',
    title: 'Get Sunlight',
    description: '15-20 minutes of morning sunlight helps regulate circadian rhythm and boosts vitamin D production.',
  },
  {
    id: 3,
    icon: 'ri-walk-line',
    title: 'Move Daily',
    description: 'Even 30 minutes of walking can improve cardiovascular health, mood, and energy levels.',
  },
  {
    id: 4,
    icon: 'ri-restaurant-line',
    title: 'Eat Mindfully',
    description: 'Chew slowly, avoid distractions, and listen to your body\'s hunger and fullness cues.',
  },
  {
    id: 5,
    icon: 'ri-moon-line',
    title: 'Prioritize Sleep',
    description: 'Aim for 7-9 hours of quality sleep. Keep your bedroom cool, dark, and screen-free.',
  },
  {
    id: 6,
    icon: 'ri-heart-pulse-line',
    title: 'Manage Stress',
    description: 'Practice deep breathing, meditation, or journaling to reduce cortisol and improve mental health.',
  },
];

export default function HealthTips() {
  return (
    <section className="py-20 bg-gradient-to-br from-emerald-50 via-teal-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4" style={{fontFamily: '"Playfair Display", serif'}}>
            Daily Wellness Tips
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Simple, science-backed habits you can implement today for better health and vitality
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tips.map((tip) => (
            <div
              key={tip.id}
              className="bg-white rounded-lg p-6 border border-gray-100 hover:shadow-lg transition-all duration-300 group cursor-pointer"
            >
              <div className="w-14 h-14 bg-emerald-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-emerald-600 transition-colors">
                <i className={`${tip.icon} text-2xl text-emerald-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{tip.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{tip.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl p-8 md:p-12 border border-emerald-100 shadow-sm">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-shrink-0">
              <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center">
                <i className="ri-mail-line text-4xl text-emerald-600"></i>
              </div>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Subscribe to Our Newsletter</h3>
              <p className="text-gray-600">
                Get weekly wellness tips, exclusive articles, and natural health insights delivered to your inbox
              </p>
            </div>
            <div className="flex-shrink-0">
              <button className="px-8 py-3 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors shadow-md whitespace-nowrap cursor-pointer">
                Subscribe Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
